<template>
  <div class="content">
    <div class="my-info">
      <div class="my-info-name">
        <div class="my-info-image">
          <i><img :src="vipInfo.currentVipImage" alt=""></i>
        </div>
        <div class="my-info-text">
          <span v-if="user.language === 'jp'" class="D-none">
            {{ $t("Bao.welcome_you") }}、{{ memberInfo.nickname }}{{ $t("Bao.expect") }}</span>
          <span v-else class="D-none">
            {{ $t("Bao.welcome_you") }}, {{ $t("Bao.expect") }} {{ memberInfo.nickname }}</span>
          <span>{{ vipInfo.currentVipName }}</span>
          <span v-if="vipInfo.last_update_date !== 0">
            {{ $t('Bao.last_update_date') }}: {{ last_update_date }}
          </span>
        </div>
      </div>
      <ul class="my-button">
        <li>
          <!-- <button class="href-message" @click="$router.push('/user/letter')">
            <i><img :src="getThemeImagePath('icon-notice.png')" alt=""></i>
            <span>{{ $t('Bao.notify') }}</span>
          </button> -->
        </li>
      </ul>
      <div class="my-lv-frame">
        <div class="keepvip_title">
          {{ $t('Bao.upgrade_require') }}
        </div>
        <ul class="my-lv">
          <li>
            <template v-if="vipInfo.upgradeNeedDepositAmount !== 0">
              <div class="my-turnover">
                <div><span>{{ $t('Bao.accumulate_deposit') }}</span></div>
                <div class="percent">
                  <div
                    class="percent-current"
                    :style="{ 'width': upgrade_deposit_amount_percentage + '%' }"
                  />
                </div>
                <div :class="upgradeDepositAmountClass" />
                <div class="shortOf">
                  <span>{{ $t('Bao.short_of') }}</span><span> {{ deposit_amount }}</span>
                </div>
              </div>
            </template>
            <template v-if="vipInfo.upgradeNeedPerformance !== 0">
              <div class="my-turnover">
                <div><span>{{ $t('Bao.accumulate_turnover') }}</span></div>
                <div class="percent">
                  <div
                    class="percent-current"
                    :style="{ 'width': upgrade_performance_percentage + '%' }"
                  />
                </div>
                <div :class="performanceClass" />
                <div class="shortOf">
                  <span>{{ $t('Bao.short_of') }}</span><span> {{ cumulative_flow }}</span>
                </div>
              </div>
            </template>
          </li>
        </ul>
      </div>
      <div class="personal-contaoner">
        <div class="personal_keepvip">
          <div class="keepvip_title">
            {{ $t('Bao.keep_your_VIP') }}
          </div>

          <div class="keepvip_area">
            <div class="personal_vip_detail">
              <div class="pvd-container">
                <div class="mb-10 title">
                  {{ $t('Bao.deposit_amount_full') }}
                </div>
                <span class="mb-0 value">
                  <b>
                    {{ keep_deposit }}
                  </b>
                </span>
              </div>
              <span :class="depositAmountClass" />
            </div>

            <div class="personal_vip_detail">
              <div class="pvd-container">
                <div class="mb-10 title">
                  {{ $t('Bao.cumulative_flow') }}
                </div>
                <span class="mb-0 value">
                  <b>
                    {{ keep_bet_amount }}
                  </b>
                </span>
              </div>
              <span :class="detailClass" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="h5">
      {{ $t("Bao.current_type") }}
    </div>
    <div class="personal_state">
      <div class="personal_area">
        <div class="state">
          <div class="wallet-tx-xl " @click="refreshGold('personal')">
            {{ $t("Bao.main_balance") }}

            <img v-if="goldInfo" class="refresh" :src="getThemeImagePath('icon-refresh.png')" alt="refresh gold">
            <i v-else class="fa fa-spinner fa-pulse fa-fw" />
          </div>
          <div class="bottom-line" />
          <div class="balance wallet-tx-xl wallet-tx-color">
            {{ currency }} {{ mainGold | numberFormat }}
          </div>
        </div>

        <div class="state">
          <div class="wallet-tx-xl">
            {{ $t("Bao.bonus_balance") }}
          </div>
          <div class="bottom-line" />
          <div class="balance wallet-tx-xl wallet-tx-color">
            {{ currency }} {{ bonusGold | numberFormat }}
          </div>
        </div>

        <div class="state">
          <div class="wallet-tx-xl">
            {{ $t('Bao.cumulative_revenue_2') }}
          </div>
          <div class="bottom-line" />
          <div class="balance wallet-tx-xl wallet-tx-color">
            {{ memberInfo.main_turnover | numberFormat }}
          </div>
        </div>

        <div class="state">
          <div class="wallet-tx-xl">
            {{ $t('Bao.katsu_point') }}
          </div>
          <div class="bottom-line" />
          <div class="balance wallet-tx-xl wallet-tx-color">
            {{ point | numberFormatThird }}
          </div>
        </div>
      </div>

      <div class="personal_area_txbox">
        <ol class="state_txbox">
          <li>{{ $t('Bao.cumulative_valid_wagers_principal_2') }}</li>
          <li>{{ $t('Bao.cumulative_valid_wagers_principal_3') }}</li>
        </ol>
      </div>
    </div>
    <div class="h5" />
    <div class="my-money my-wallet-frame">
      <div class="my-wallet">
        <h5>{{ $t('Bao.common_wallet') }}</h5>
        <hr>
        <ul class="wallet-content">
          <li class="wallet-items wallet-tx">
            <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
            <span class="text-align-R balance wallet-tx-xl">{{ currency }} {{ user.mainGold | numberFormat }}</span>
          </li>
          <li class="wallet-items">
            <span class="wallet-tx-xl">{{ $t('Bao.available_withdrawal_amount') }}</span>
            <span class="text-align-R balance">{{ currency }} {{ deposit_limit !== 0 ? 0 : user.mainGold | numberFormat }}</span>
          </li>
          <li class="wallet-items">
            <span class="align-center">{{ $t('Bao.deposit_limit') }}
            </span>
            <span class="text-align-R balance">{{ deposit_limit | numberFormat }}</span>
          </li>
        </ul>
        <div class="my-wallet-BTN">
          <button class="BTN-style-1" @click="$router.push('/deposit')">
            {{ $t('Bao.deposit') }}
          </button>
          <button class="BTN-style-2" @click="$router.push('/withdrawal')">
            {{ $t('Bao.withdrawal') }}
          </button>
        </div>
      </div>

      <div class="my-wallet">
        <h5>{{ $t('Bao.bonus_gold') }}</h5>
        <hr>
        <ul class="wallet-content">
          <li class="wallet-items wallet-tx">
            <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
            <span class="text-align-R balance wallet-tx-xl">{{ currency }} {{ user.bonusGold | numberFormat }}</span>
          </li>
          <li class="wallet-items">
            <span class="align-center">{{ $t('Bao.deposit_limit') }}
              <i class="icon-infor" @click="showModel(permissionInfo.bonus_wallet_rule)">
                <img :src="getThemeImagePath('icon-detail.png')" alt="">
              </i>
            </span>
            <span class="text-align-R balance">{{ bonus_transfer_limit | numberFormat }}</span>
          </li>
        </ul>
      </div>

      <div class="my-wallet">
        <h5>{{ $t('Bao.commission_gold') }}</h5>
        <hr>
        <ul class="wallet-content">
          <li class="wallet-items wallet-tx">
            <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
            <span class="text-align-R balance wallet-tx-xl">{{ currency }} {{ user.commissionGold | numberFormat }}</span>
          </li>
        </ul>
        <div class="my-wallet-BTN">
          <button class="BTN-style-2 btn-transfer" @click="showTransferModal">
            {{ $t('Bao.transfer') }}
          </button>
          <button class="BTN-style-2" @click="goWithdrawal">
            {{ $t('Bao.withdrawal') }}
          </button>
        </div>
      </div>
    </div>
    <performance-modal :is-active="showModal" :limit-text="limitText" @hideModel="hideModel" />
    <transfer-modal
      :is-active="showTransfer"
      :trading-balance=" user.commissionGold"
      @hideTransferModal="hideTransferModal"
    />
  </div>
</template>

<script>
import { showNotice, refreshGold, getThemeImagePath } from '@/utils/tool'
import performanceModal from '@/components/modal/performanceModal'
import transferModal from '@/components/modal/transferModal'
import { mapGetters } from 'vuex'

export default {
  components: {
    performanceModal,
    transferModal
  },
  data() {
    return {
      showModal: false,
      showTransfer: false,
      limitText: '',
      detailClass: '',
      performanceClass: '',
      depositAmountClass: '',
      upgradeDepositAmountClass: ''
    }
  },
  computed: {
    ...mapGetters(['user', 'memberInfo', 'brand', 'permissionInfo', 'goldLoading', 'goldInfo', 'mainGold', 'bonusGold', 'point']),
    vipInfo() {
      return this.user.vipInfo
    },
    currency() {
      return this.brand.currency
    },
    last_update_date() {
      const last_update_time = this.vipInfo.last_upgrade_time
      return last_update_time === 0 ? 0 : this.$options.filters.dateFormat(last_update_time)
    },
    upgrade_deposit_amount_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentDepositAmount) / parseInt(this.vipInfo.upgradeNeedDepositAmount) * 100
      return percentage > 100 ? 100 : percentage
    },
    upgrade_performance_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentPerformance) / parseInt(this.vipInfo.upgradeNeedPerformance) * 100
      return percentage > 100 ? 100 : percentage
    },
    deposit_limit() {
      const limit = parseFloat(this.memberInfo.withdrawal_limit) - parseFloat(this.memberInfo.main_turnover)
      return limit > 0 ? limit : 0
    },
    bonus_transfer_limit() {
      const limit = parseFloat(this.memberInfo.bonus_transfer_limit) - parseFloat(this.memberInfo.bonus_turnover)
      return limit > 0 ? limit : 0
    },
    deposit_amount() {
      const amount = this.vipInfo.upgradeNeedDepositAmount - this.vipInfo.upgradeCurrentDepositAmount
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    cumulative_flow() {
      const amount = this.vipInfo.upgradeNeedPerformance - this.vipInfo.upgradeCurrentPerformance
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    keep_deposit() {
      const amount = this.vipInfo.keep_deposit - this.vipInfo.upgradeCurrentDepositAmount
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return this.$t('Bao.user_complete')
      }
    },
    keep_bet_amount() {
      const amount = this.vipInfo.keep_bet_amount - this.vipInfo.upgradeCurrentPerformance
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return this.$t('Bao.user_complete')
      }
    }
  },
  created() {

  },
  mounted() {
    this.updateClasses()
  },
  methods: {
    refreshGold(position) {
      refreshGold(position)
    },
    showModel(text) {
      this.limitText = text
      this.showModal = true
    },
    showTransferModal() {
      showNotice(this.$t('Bao.transfer_notice_1') + '<br><br>' + this.$t('Bao.transfer_notice_2') + '<br>' + this.$t('Bao.transfer_notice_3'), () => {
        this.showTransfer = true
      })
    },
    hideModel() {
      this.showModal = false
    },
    hideTransferModal() {
      this.showTransfer = false
    },
    updateClasses() {
      this.upgradeDepositAmountClass = this.calculateClass(this.vipInfo.upgradeCurrentDepositAmount, this.vipInfo.upgradeNeedDepositAmount)
      this.performanceClass = this.calculateClass(this.vipInfo.upgradeCurrentPerformance, this.vipInfo.upgradeNeedPerformance)
      this.depositAmountClass = this.calculateClass(this.vipInfo.upgradeCurrentDepositAmount, this.vipInfo.keep_deposit)
      this.detailClass = this.calculateClass(this.vipInfo.upgradeCurrentPerformance, this.vipInfo.keep_bet_amount)
    },
    calculateClass(current, target) {
      const formattedCurrent = parseInt(current)
      const formattedTarget = parseInt(target)
      if (formattedCurrent === 0 && formattedTarget === 0) {
        return 'check-off'
      }
      return formattedCurrent >= formattedTarget ? 'check-on' : 'check-off'
    },
    getThemeImagePath,
    goWithdrawal() {
      localStorage.setItem('fromPersonalToWithdrawal', true)
      this.$router.push('/withdrawal')
    }
  }
}
</script>

